import { makeStyles } from 'tss-react/mui';

export const useSupportArticleStyles = makeStyles({ name: 'PatientSupportArticle' })(theme => ({
  content: {
    maxWidth: 900,
    margin: '0 auto',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
  },
}));
